<div class="container-fluid  ">
    <div class="row main">
        <div class="col-md-4 col-sm-12 col-xs-12 col-lg-4 col-xl-4">
            <div class="img-zoom-container">
                <img id="myimage" class="slider" [src]="productMainImage" (click)="viewImage()" style="cursor:pointer;">
            </div>
        </div>
        <div class="col-md-8 col-sm-12 col-xs-12 col-xl-8 col-lg-8 ">
            <div class="text">
                <h3 style="cursor: pointer;" (click)="moreImage(false)">{{productName}}</h3>
            </div>
            <mat-tab-group>
                <mat-tab label="Product details">

                    <div class="table-responsive">
                        <table class="table">
                            <tbody>
                                <tr *ngFor="let item of productDetails| keyvalue:originalOrder;let i=index">
                                    <td>{{(item.key)}}:</td>
                                    <td class="table1">{{item.value}}</td>
                                </tr>
                                <tr *ngFor="let item of productAttributes">
                                    <td>{{(item.productAttributeName)}}:</td>
                                    <td class="table1">{{item.productAtrributeValue}}
                                        <span *ngIf="item.productAttributeName == 'Available Stock'"style ="text-transform:none !important; padding-left:200px;">*The roll size may vary</span>
                                    </td>
                                    <!-- <td *ngIf="item.productAttributeName == 'Available Stock'"style ="text-transform:none !important">*The roll size may vary</td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
    <hr>
    <div class="similar-products-head">
        <h4>Colorways
        </h4>
    </div>
    <hr>
    <div class="row spacing-left">
        <div class="col-md-12 col-sm-12 col-xs-12 sol-xl-12 col-lg-12">
            <!-- <div class="col-md-1 col-sm-12 col-xs-12 col-xl-1 col-lg-1"></div> -->
            <div *ngFor="let products of data;" class="col-md-3 col-sm-12 col-xs-12 col-xl-3 col-lg-3 ">
                <img class="image-size click-point" (click)="moreImage(products)" [src]="products.path" />
                <div class="similar-products ">
                    <p class="image-name">{{products.productName}}</p>
                </div>
            </div>

        </div>

    </div>

    <mat-paginator *ngIf="colorways!=null" [length]="colorways.length" [pageSize]="size" [pageIndex]="page"
        [pageSizeOptions]="[15, 30, 45]" (page)="getData($event)">
    </mat-paginator>
    <div *ngIf="colorways==null" class="similar-products-head">
        <h4 style="font-size: large;text-align: center;">Colorways not available</h4>
    </div>
</div>